import React, {Component, PropTypes} from 'react'
import {Input, DropdownButton, MenuItem} from 'react-bootstrap'
import i18n from '../i18n'

export const timeUnits = {
    'd': 24 * 3600 * 1000,
    'h': 3600 * 1000,
    'm': 60 * 1000
}

function toMeasueAndUnit(units, value) {
    const unitNames = Object.keys(units)

    for (var i = 0 ; i < unitNames.length ; i++) {
        const unitName = unitNames[i]
        const unitFactor = units[unitName]

        if (value && (value % unitFactor == 0)) {
            return {
                measure: value / unitFactor,
                unit: unitName
            }
        }

        if (i == unitNames.length - 1) {
            return {
                measure: value && Math.round(value / unitFactor),
                unit: unitName
            }
        }
    }
}

function toMeasure(units, value, unitName) {
    const unitFactor = units[unitName]
    return value && (value / unitFactor)
}

function toValue(units, measure, unitName) {
    const unitFactor = units[unitName]
    return measure && (measure * unitFactor)
}

class MeasureInput extends Component {
    static propTypes = {
        units: PropTypes.object.isRequired,
        value: PropTypes.number,
        onChange: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {units, value} = this.props

        const {measure, unit} = toMeasueAndUnit(units, value)
        this.setState({measure, unit})
        this._unit = unit
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.units != this.props.units
            || nextProps.value != this.props.value) {
            const {units, value} = nextProps

            if (value != this._nextValue) {
                const {measure, unit} = toMeasueAndUnit(units, value)
                this.setState({measure, unit})
                this._unit = unit
            } else {
                const measure = toMeasure(units, value, this._unit)
                this.setState({measure})
            }
        }
    }

    _selectUnit(event, unit) {
        const {units, onChange} = this.props
        const {measure} = this.state

        this._nextValue = toValue(units, measure, unit)
        onChange(this._nextValue)

        this.setState({unit})
        this._unit = unit
    }

    _selectMeasure(event) {
        const {units, onChange} = this.props
        const {unit} = this.state

        const measure = parseInt(event.target.value)

        this._nextValue = toValue(units, measure, unit)
        onChange(this._nextValue)
    }

    render() {
        const {units, value, onChange, ...others} = this.props
        const {measure, unit} = this.state

        const unitInputButton = (
            <DropdownButton
                title={i18n.unitEnum[unit]}
                onSelect={(e, k) => this._selectUnit(e, k)}>
                {Object.keys(units).map((unit) => (
                    <MenuItem
                        key={unit}
                        eventKey={unit}>
                        {i18n.unitEnum[unit]}
                    </MenuItem>
                ))}
            </DropdownButton>
        )

        return (
            <Input
                type='text'
                value={measure}
                onChange={(e) => this._selectMeasure(e)}
                buttonAfter={unitInputButton}
                {...others} />
        )
    }
}

export default MeasureInput


// WEBPACK FOOTER //
// ./lib/core/components/MeasureInput.js